import 'jquery.nicescroll';
import isMobile from 'ismobilejs';

export default function() {
    var defaults = {
        background: 'rgba(255, 255, 255, 0.1)',
        cursorcolor: 'rgba(255, 255, 255, 0.8)',
        cursorwidth: '8px',
        cursorborder: '0',
        cursorborderradius: '0',
        railoffset: 'true',
        horizrailenabled: false
    };
    var detectMobile = isMobile.any;

    return {
        create: function(container, options) {
            if (!detectMobile) {
                $(container).niceScroll($.extend({}, defaults, options));
            }
        },
        destroy: function(container) {
            if (!detectMobile) {
                $(container).niceScroll().remove();
                $(container).removeAttr('style');
            }
        }
    };
}



// WEBPACK FOOTER //
// ./frontend/src/js/modules/scrollbar.js